import { rankWith,and, isStringControl, schemaMatches, schemaTypeIs, isEnumControl, optionIs, JsonSchema, isNumberControl} from '@jsonforms/core';

interface MyCustomSchemaProperties {
  isComment?: boolean; // Your custom property
  multipleSelect?:boolean
}

type MyCustomJsonSchema = JsonSchema & MyCustomSchemaProperties;

export const CustomTextInputTester = rankWith(
  3, // the rank when this tester should be applied (higher means more specific)
  isStringControl,
);

export const CustomDateInputTester = rankWith(
  5, // the rank when this tester should be applied (higher means more specific)

  and(
    schemaTypeIs('string'),
    schemaMatches(schema => schema.format === 'datetime' || schema.format === 'datetime')
  )
  ,
);

export const CustomTextAreaTester = rankWith(
  4, // This is a sample rank value; adjust as needed based on other testers
  and(
    schemaTypeIs('string'),
    optionIs('multiLine', true)
  )
);

export const CustomSelectTester = rankWith(
  4, // This is a sample rank value; adjust as needed based on other testers

  isEnumControl
  
);


export const CustomTextInputHiddenTester = rankWith(
  4, // Use a high rank to prioritize this renderer
  schemaMatches((schema) => schema.type === 'string' && schema.format === 'hidden')
);

export const CustomArraySelectTester = rankWith(
  9,
  schemaTypeIs('array')
);

export const CustomArray2SelectTester = rankWith(
  10,
  and(
    schemaTypeIs("array"),
    schemaMatches(
      (schema) =>
        schema?.title === "Payment Plan"
    )
  )
);
export const CustomMultiSelectTester = rankWith(
  9,
  schemaMatches((schema) => schema.format === "select" && schema.type==="array")
);
export const CustomCommentTester = rankWith(
  6, // Adjust the rank as needed
  schemaMatches((schema: MyCustomJsonSchema) => schema.isComment === true)
);

export const CustomInputPairTester = rankWith(
  7,
  schemaTypeIs('array')
);

export const CustomTextInputPasswordTester = rankWith(
  4, // Higher rank to prioritize this renderer
  schemaMatches((schema) => schema.format === 'password')
);

export const CustomFileUploadTester = rankWith(
  4, // Higher rank to prioritize this renderer
  schemaMatches((schema) => schema.format === 'data-url')
);

export const CustomNumberTextInputTester = rankWith(
  3, // the rank when this tester should be applied (higher means more specific)
  schemaTypeIs("number")
);

export const CustomAdventureArrayTester = rankWith(
  10, // High priority for specific adventure array rendering
  and(
    schemaTypeIs("array"),
    schemaMatches(
      (schema) => schema?.title === "Programme Adventures" || schema?.format === "adventure-array"
    )
  )
);
